module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'VehicleState': 1,
      'VehicleState--variantCompatibilityChecker': _vm.variant == 'compatibility-checker',
      'VehicleState--variantHeaderOverlap': _vm.variant == 'header-overlap',
      'VehicleState--variantProductOverlay': _vm.variant == 'product-overlay',
    }
  }, [_c('transition', {
    attrs: {
      "name": "VehicleState_fade",
      "mode": "out-in"
    }
  }, [(_vm.vehicle) ? _c('vehicle-state-vehicle', {
    attrs: {
      "productId": this.productId,
      "variant": _vm.variant
    }
  }) : _c('vehicle-state-empty', {
    attrs: {
      "variant": _vm.variant
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09d60d34","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/resources/scripts/components/garage/VehicleState.vue
// module id = 1455
// module chunks = 0